import { Button, ButtonProps } from '@repo/atomic-components';
import { classNames } from 'primereact/utils';

export const OutlineIconButton = ({ className, pt, ...props }: ButtonProps) => (
  <Button
    {...props}
    outlined
    className={classNames('hover:!bg-fletchers-gray-50 !h-[32px] !w-[32px] !justify-center !p-0', className)}
    pt={{ ...pt, label: { className: '!hidden', ...pt?.label } }}
  />
);
